import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const featurePills = ['🎁 26 carpetas organizadas', '🌸 +1.000 diseños por carpeta', '⚡ Descarga instantánea', '✏️ 100% editable en Canva', '💰 Licencia de reventa'];
  return <section className="relative min-h-screen w-full bg-gradient-to-b from-pink-50 via-white to-white overflow-hidden" data-id="element-78">
      {/* Decorative background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-79">
        <motion.div className="absolute top-20 left-10 text-6xl opacity-20" animate={{
        y: [0, -15, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-80">
          🎀
        </motion.div>
        <motion.div className="absolute top-40 right-20 text-5xl opacity-20" animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 3.5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.5
      }} data-id="element-81">
          ✨
        </motion.div>
        <motion.div className="absolute bottom-40 left-20 text-4xl opacity-20" animate={{
        y: [0, -12, 0]
      }} transition={{
        duration: 3,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 1
      }} data-id="element-82">
          🎉
        </motion.div>
        <motion.div className="absolute bottom-60 right-10 text-5xl opacity-20" animate={{
        y: [0, -8, 0]
      }} transition={{
        duration: 4.5,
        repeat: Infinity,
        ease: 'easeInOut',
        delay: 0.3
      }} data-id="element-83">
          🌸
        </motion.div>
      </div>

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-20" data-id="element-84">
        <div className="text-center" data-id="element-85">
          {/* Badge */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-86">
            <span className="inline-block px-6 py-2 bg-rose-100 text-rose-600 rounded-full text-sm font-semibold mb-8" data-id="element-87">
              🎀 Kit Imprimible Profesional
            </span>
          </motion.div>

          {/* Headline */}
          <motion.h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extrabold text-slate-900 leading-tight mb-6" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} data-id="element-88">
            +25.000 Diseños para Fiestas
            <br data-id="element-89" />
            <span className="bg-gradient-to-r from-rose-500 to-pink-500 bg-clip-text text-transparent" data-id="element-90">
              Editables, Imprimibles y Listos para Vender
            </span>{' '}
            ✨
          </motion.h1>

          {/* Subheadline */}
          <motion.p className="text-lg sm:text-xl text-slate-600 max-w-3xl mx-auto mb-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-91">
            26 carpetas organizadas con más de 1.000 diseños cada una. Todo
            listo para editar en Canva e imprimir desde casa.
          </motion.p>

          {/* Slogan */}
          <motion.p className="text-xl sm:text-2xl md:text-3xl font-extrabold mb-8" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.25
        }} data-id="element-92">
            <span className="text-rose-500" data-id="element-93">Diseñá hoy.</span>{' '}
            <span className="text-pink-400" data-id="element-94">Imprimí mañana.</span>{' '}
            <span className="bg-gradient-to-r from-amber-500 to-amber-400 bg-clip-text text-transparent" data-id="element-95">
              Ganá siempre.
            </span>
          </motion.p>

          {/* CTA Button */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} data-id="element-96">
            <a href="https://magiadigital.online/checkouts/cn/hWN9TYd7nIHOv98RJ6pjImQM/es-ar?_r=AQABPAMwqwcFHsaNx77xI9-vQVNjUUJUKqqMcQTwOKcBl4s&preview_theme_id=158917099778" target="_blank" rel="noopener noreferrer" className="shimmer-btn inline-flex items-center justify-center px-10 py-5 bg-gradient-to-r from-rose-500 to-pink-500 text-white text-xl font-bold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300" data-id="element-97">
              🛒 Quiero mi Kit Ahora — $27.990 ARS
            </a>
            <motion.p className="mt-3 text-sm text-slate-500" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.5
          }} data-id="element-98">
              <span className="line-through text-slate-400" data-id="element-99">$89.990</span>{' '}
              <span className="font-bold text-rose-600" data-id="element-100">$27.990 ARS</span>{' '}
              <span data-id="element-101">· pago único</span>
            </motion.p>
          </motion.div>

          {/* Trust badges */}
          <motion.div className="mt-8 flex flex-wrap justify-center gap-4 text-sm text-slate-600" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} data-id="element-102">
            <span className="flex items-center gap-1" data-id="element-103">
              ✅ Descarga inmediata
            </span>
            <span className="hidden sm:inline text-slate-300" data-id="element-104">·</span>
            <span className="flex items-center gap-1" data-id="element-105">
              ✅ Editable en Canva gratis
            </span>
            <span className="hidden sm:inline text-slate-300" data-id="element-106">·</span>
            <span className="flex items-center gap-1" data-id="element-107">
              ✅ Licencia de reventa incluida
            </span>
          </motion.div>

          {/* Feature pills */}
          <motion.div className="mt-12 flex flex-wrap justify-center gap-3" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} data-id="element-108">
            {featurePills.map((pill, index) => <motion.span key={pill} className="px-4 py-2 bg-white border border-rose-200 rounded-full text-sm font-medium text-slate-700 shadow-sm" initial={{
            opacity: 0,
            scale: 0.8
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.4,
            delay: 0.7 + index * 0.1
          }} data-id="element-109">
                {pill}
              </motion.span>)}
          </motion.div>
        </div>
      </div>
    </section>;
}